import React from 'react'
import './M_Header.css'
import PropTypes from 'prop-types'

export const MHeader = ({ element, color, backgroundColor, notsticky }) => {

    notsticky = !notsticky
    color = color || 'var(--color-grey)'
    backgroundColor = backgroundColor || 'var(--color-white)'

    return (
        <div
            data-testid='header-component'
            className='headerComponent'
            style={notsticky ? {
                background: backgroundColor,
                borderBottom: `1px solid ${color}`,
                position: 'inherit'
            } : {
                background: backgroundColor,
                borderBottom: `1px solid ${color}`
            }}>
            {element && React.cloneElement(element, { 'data-testid': 'header-element' })}
        </div >

    )
}

MHeader.propTypes = {
    element: PropTypes.element,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    notsticky: PropTypes.bool
}